module.exports = __webpack_public_path__ + "media/images/emblems/Versoix-coat_of_arms-b900dfc51b1b67f088d6b553ef036ae2.svg";